import profile from './profile'
import config from './config'
import driving from './driving'
import taxes from './taxes'
import creditBalance from './creditBalance'
import trainingCertifications from './trainingCertifications'
import earningsStatement from './earningsStatement'
import mfa from './mfa'
import seattle from './seattle'
import isLocked from './isLocked'
import lockReason from './lockReason'
import scorecardSummary from './scorecardSummary'
import senderRecognitions from './senderRecognitions'

function metaReduce(...reducers) {
  return (previous, current) => reducers.reduce((p, r) => r(p, current), previous)
}

const reducers = metaReduce(
  config,
  mfa,
  profile,
  driving,
  taxes,
  creditBalance,
  trainingCertifications,
  earningsStatement,
  seattle,
  isLocked,
  lockReason,
  scorecardSummary,
  senderRecognitions
)

export default function rootReducer(state, action) {
  switch (action.type) {
    case 'SIGN_OUT': {
      const cleaned = reducers({}, action)

      cleaned.config.badges = [...state.config.badges]
      cleaned.config.appRootPath = state.config.appRootPath

      return cleaned
    }
    default:
      return reducers(state, action)
  }
}
